// src/components/root-wrapper.js
import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material'; // Import CssBaseline
import theme from '../theme';
import { AuthProvider } from '../contexts/authContext';
import { AdminProvider } from '../contexts/adminContext'; 

export const wrapRootElement = ({ element }) => (
  <ThemeProvider theme={theme}>
    <CssBaseline /> {/* Add CssBaseline here */}
    <AuthProvider>
      <AdminProvider>
        {element}
      </AdminProvider>
    </AuthProvider>
  </ThemeProvider>
);
